<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Stampanti M3250, MS622">
     Stampanti M3250, MS622
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_it" title="Informazioni sulla sicurezza">
     Informazioni sulla sicurezza
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Convenzioni">
      Convenzioni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Dichiarazioni del prodotto">
      Dichiarazioni del prodotto
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_it" title="Informazioni sulla stampante">
     Informazioni sulla stampante
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_it" title="Individuazione delle informazioni sulla stampante">
      Individuazione delle informazioni sulla stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_it" title="Scelta della posizione della stampante">
      Scelta della posizione della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_it" title="Configurazioni della stampante">
      Configurazioni della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_it" title="Collegamento dei cavi">
      Collegamento dei cavi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_it" title="Tramite il pannello di controllo">
      Tramite il pannello di controllo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_it" title="Informazioni sullo stato del pulsante di accensione e della spia luminosa">
      Informazioni sullo stato del pulsante di accensione e della spia luminosa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-network-setup-page-topic.html#printing-network-setup-page_it" title="Stampa della pagina delle impostazioni di rete">
      Stampa della pagina delle impostazioni di rete
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_it" title="Impostazione e uso delle applicazioni della schermata iniziale">
     Impostazione e uso delle applicazioni della schermata iniziale
    </a>
   </p>
   <div id="divd0e748">
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_it" title="Uso della schermata iniziale">
      Uso della schermata iniziale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_it" title="Personalizzazione della schermata iniziale">
      Personalizzazione della schermata iniziale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_it" title="Uso di Personalizzazione schermo">
      Uso di Personalizzazione schermo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_it" title="Configurazione delle Impostazioni eco">
      Configurazione delle Impostazioni eco
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_it" title="Utilizzo di Assistenza clienti">
      Utilizzo di Assistenza clienti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_it" title="Utilizzo di Generatore codice QR">
      Utilizzo di Generatore codice QR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_it" title="Configurazione di Quote periferica">
      Configurazione di Quote periferica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_it" title="Creazione di un profilo Connettore cloud">
      Creazione di un profilo Connettore cloud
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1094" title="Gestione dei segnalibri">
      Gestione dei segnalibri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1171" title="Gestione dei contatti">
      Gestione dei contatti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_it" title="Configurazione e utilizzo delle funzioni di accessibilit&agrave;">
     Configurazione e utilizzo delle funzioni di accessibilit&agrave;
    </a>
   </p>
   <div id="divd0e1290">
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_it" title="Attivazione della Guida vocale">
      Attivazione della Guida vocale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_it" title="Navigazione su schermo mediante gesti">
      Navigazione su schermo mediante gesti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_it" title="Abilitazione della modalit&agrave; di ingrandimento">
      Abilitazione della modalit&agrave; di ingrandimento
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_it" title="Regolazione della velocit&agrave; del parlato della Guida vocale">
      Regolazione della velocit&agrave; del parlato della Guida vocale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_it" title="Uso della tastiera sul display">
      Uso della tastiera sul display
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_it" title="Attivazione PIN o password vocale">
      Attivazione PIN o password vocale
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_it" title="Caricamento della carta e dei supporti speciali">
     Caricamento della carta e dei supporti speciali
    </a>
   </p>
   <div id="divd0e1495">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_it" title="Impostazione del tipo e del formato carta">
      Impostazione del tipo e del formato carta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_it" title="Configurazione delle impostazioni di dimensione carta Universale">
      Configurazione delle impostazioni di dimensione carta Universale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_it" title="Caricamento dei vassoi">
      Caricamento dei vassoi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_it" title="Caricamento dell'alimentatore multiuso">
      Caricamento dell'alimentatore multiuso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_it" title="Collegamento dei vassoi">
      Collegamento dei vassoi
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_it" title="Supporto carta">
     Supporto carta
    </a>
   </p>
   <div id="divd0e1662">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-goldfinger-topic.html#supported-paper-sizes-goldfinger_it" title="Formati carta supportati">
      Formati carta supportati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-goldfinger-topic.html#supported-paper-types-goldfinger_it" title="Tipi di carta supportati">
      Tipi di carta supportati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-goldfinger-topic.html#supported-paper-weights-goldfinger_it" title="Pesi della carta supportati">
      Pesi della carta supportati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_it" title="Carta non adatta">
      Carta non adatta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_it" title="Uso di carta riciclata">
      Uso di carta riciclata
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_it" title="Stampa">
     Stampa
    </a>
   </p>
   <div id="divd0e2521">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_it" title="Stampa da un computer">
      Stampa da un computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2547" title="Stampa usando un dispositivo cellulare">
      Stampa usando un dispositivo cellulare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_it" title="Stampa da unit&agrave; flash">
      Stampa da unit&agrave; flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_it" title="Unit&agrave; flash e tipi di file supportati">
      Unit&agrave; flash e tipi di file supportati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_it" title="Configurazione di processi riservati">
      Configurazione di processi riservati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_it" title="Stampa di processi riservati e in attesa">
      Stampa di processi riservati e in attesa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_it" title="Stampa da un profilo Connettore cloud">
      Stampa da un profilo Connettore cloud
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_it" title="Stampa di un elenco di esempi di font">
      Stampa di un elenco di esempi di font
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_it" title="Stampa di un elenco di directory">
      Stampa di un elenco di directory
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_it" title="Annullamento di un processo di stampa">
      Annullamento di un processo di stampa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_it" title="Informazioni sui menu della stampante">
     Informazioni sui menu della stampante
    </a>
   </p>
   <div id="divd0e3057">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_it" title="Mappa dei menu">
      Mappa dei menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3376" title="Periferica">
      Periferica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e5222" title="Stampa">
      Stampa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e6480" title="Carta">
      Carta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e6742" title="Unit&agrave; USB">
      Unit&agrave; USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6963" title="Rete/Porte">
      Rete/Porte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8753" title="Protezione">
      Protezione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e9888" title="Rapporti">
      Rapporti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_it" title="Guida">
      Guida
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e10136" title="Risoluzione dei problemi">
      Risoluzione dei problemi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_it" title="Stampa della pagina impostazioni menu">
      Stampa della pagina impostazioni menu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_it" title="Protezione della stampante">
     Protezione della stampante
    </a>
   </p>
   <div id="divd0e10188">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_it" title="Individuazione dello slot di sicurezza">
      Individuazione dello slot di sicurezza
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_it" title="Cancellazione della memoria della stampante">
      Cancellazione della memoria della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_it" title="Cancellazione della memoria del disco fisso della stampante">
      Cancellazione della memoria del disco fisso della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_it" title="Codifica del disco fisso della stampante">
      Codifica del disco fisso della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_it" title="Ripristino delle impostazioni predefinite di fabbrica">
      Ripristino delle impostazioni predefinite di fabbrica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_it" title="Dichiarazione di volatilit&agrave;">
      Dichiarazione di volatilit&agrave;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_it" title="Manutenzione della stampante">
     Manutenzione della stampante
    </a>
   </p>
   <div id="divd0e10402">
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_it" title="Impostazione degli avvisi e-mail">
      Impostazione degli avvisi e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_it" title="Regolazione del volume predefinito delle cuffie">
      Regolazione del volume predefinito delle cuffie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e10464" title="Collegamento in rete">
      Collegamento in rete
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_it" title="Impostazione della stampa seriale (solo Windows)">
      Impostazione della stampa seriale (solo Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_it" title="Pulizia della stampante">
      Pulizia della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_it" title="Ordinazione di materiali di consumo e componenti">
      Ordinazione di materiali di consumo e componenti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e11200" title="Sostituzione di materiali di consumo e componenti della stampante">
      Sostituzione di materiali di consumo e componenti della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e11344" title="Spostamento della stampante">
      Spostamento della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e11400" title="Risparmio energetico e della carta">
      Risparmio energetico e della carta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e11504" title="Riciclo">
      Riciclo
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_it" title="Rimozione degli inceppamenti">
     Rimozione degli inceppamenti
    </a>
   </p>
   <div id="divd0e11537">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_it" title="Come evitare gli inceppamenti">
      Come evitare gli inceppamenti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_it" title="Individuazione dell'area dell'inceppamento">
      Individuazione dell'area dell'inceppamento
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_it" title="Inceppamento carta nello sportello A">
      Inceppamento carta nello sportello A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_it" title="Inceppamento della carta nello sportello posteriore">
      Inceppamento della carta nello sportello posteriore
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_it" title="Inceppamento della carta nel raccoglitore standard">
      Inceppamento della carta nel raccoglitore standard
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_it" title="Inceppamento della carta nell'unit&agrave; duplex">
      Inceppamento della carta nell'unit&agrave; duplex
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_it" title="Inceppamento della carta nei vassoi">
      Inceppamento della carta nei vassoi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_it" title="Inceppamento della carta nell'alimentatore multiuso">
      Inceppamento della carta nell'alimentatore multiuso
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_it" title="Risoluzione dei problemi">
     Risoluzione dei problemi
    </a>
   </p>
   <div id="divd0e11813">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e11816" title="Problemi di connessione di rete">
      Problemi di connessione di rete
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e12130" title="Problemi delle opzioni hardware">
      Problemi delle opzioni hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e12404" title="Problemi con i materiali di consumo">
      Problemi con i materiali di consumo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_it" title="Problemi di alimentazione della carta">
      Problemi di alimentazione della carta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_it" title="Problemi di stampa">
      Problemi di stampa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_it" title="Come contattare l'assistenza clienti">
      Come contattare l'assistenza clienti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_it" title="Aggiornamento e migrazione">
     Aggiornamento e migrazione
    </a>
   </p>
   <div id="divd0e15394">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e15397" title="Hardware">
      Hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e15707" title="Software">
      Software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e15790" title="Firmware">
      Firmware
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_it" title="Avvertenze">
     Avvertenze
    </a>
   </p>
   <div id="divd0e15877">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15880" title="Informazioni sul prodotto">
      Informazioni sul prodotto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15897" title="Nota sull'edizione">
      Nota sull'edizione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_it" title="Marchi">
      Marchi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_it" title="Informazioni sulla licenza">
      Informazioni sulla licenza
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_it" title="Livelli di emissione dei rumori">
      Livelli di emissione dei rumori
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_it" title="Direttiva WEEE (Rifiuti di apparecchiature elettriche ed elettroniche)">
      Direttiva WEEE (Rifiuti di apparecchiature elettriche ed elettroniche)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16001" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_it" title="Smaltimento dei prodotti">
      Smaltimento dei prodotti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16035" title="Batteria ricaricabile agli ioni di litio">
      Batteria ricaricabile agli ioni di litio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_it" title="Normativa (UE) 2023/1542">
      Normativa (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_it" title="Restituzione delle cartucce Lexmark per il riuso o il riciclo">
      Restituzione delle cartucce Lexmark per il riuso o il riciclo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_it" title="Avviso sensibilit&agrave; ad elettricit&agrave; statica">
      Avviso sensibilit&agrave; ad elettricit&agrave; statica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_it" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_it" title="Informazioni sulle temperature">
      Informazioni sulle temperature
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_it" title="Avvertenze sui prodotti laser">
      Avvertenze sui prodotti laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_it" title="Consumo di energia">
      Consumo di energia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16275" title="Avvisi sulle normative per i prodotti wireless">
      Avvisi sulle normative per i prodotti wireless
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_it" title="Avvertenza sui componenti modulari">
      Avvertenza sui componenti modulari
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_it" title="Esposizione alle radiazioni di radiofrequenza">
      Esposizione alle radiazioni di radiofrequenza
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16301" title="Conformit&agrave; alle direttive dell'Unione Europea (UE)">
      Conformit&agrave; alle direttive dell'Unione Europea (UE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_it" title="Conformit&agrave; alle direttive dell'Unione Europea (UE)">
      Conformit&agrave; alle direttive dell'Unione Europea (UE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_it" title="Informazioni sulle interferenze radio">
      Informazioni sulle interferenze radio
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue